import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import {accreditationProfile, evaluatorRole, programProfile, Session} from "../../../../services/session.service";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {ApiCallService} from "../../../../services/api-call.service";
import {ErrorMessageService} from "../../../../services/error-message.service";
import {AuthService} from "../../../../services/auth.service";
import { NotificationsService } from "../../../../services/notifications.service";
import {firstValueFrom, Subscription} from "rxjs";
import { environment } from "../../../../../environments/environment";
import {IdleWatcherService} from "../../../../services/idle-watcher.service";
import {Router} from "@angular/router";
import {first} from "rxjs/operators";

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss'],
    standalone: false
})
export class AccountMenuComponent implements OnInit, OnDestroy {

  isImpersonatedUser: boolean;
  userIsActingAsEvaluatorForAccreditor: boolean;
  currentEvaluatorRole: evaluatorRole;
  @Input() canShowMenu;
  @Input() currentUser;
  @BlockUI() blockUI: NgBlockUI;
  accreditationProfiles: accreditationProfile[];
  programProfiles: programProfile[];

  hasNotifications: boolean = false;
  openMenu: boolean = false;

  subscribers: Subscription[] = [];

  debug = !environment.production;

  lightOptions = [
    {
      label: "Dark mode",
      value: "darkMode"
    },
    {
      label: "Light mode",
      value: "lightMode"
    }
  ];
  lightMode: string = "darkMode";

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(
      !this.eRef.nativeElement.contains(event.target)  &&
      !event.target.classList.contains("notificationsExpander")
    ) {
      this.openMenu = false;
    }
  }


  constructor(
    private session: Session,
    private apiCall: ApiCallService,
    private route: Router,
    private errorMessage: ErrorMessageService,
    private auth: AuthService,
    private eRef: ElementRef,
    private notificationsService: NotificationsService,
    private idleService: IdleWatcherService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.isImpersonatedUser = this.session.isImpersonatedUser();
    this.notificationsService.getNotificationsCount();
    this.subscribers.push(
      this.notificationsService.hasNotifications.subscribe(data => {
        this.hasNotifications = data;
      }),
      this.session.lightMode.subscribe(lightMode => {
        this.lightMode = lightMode;
        this.setLightMode(this.lightMode);
      }),
    );
    this.userIsActingAsEvaluatorForAccreditor = this.session.isEvaluatorWorkingForOtherInstitution();
    if(this.userIsActingAsEvaluatorForAccreditor){
      this.currentEvaluatorRole = this.session.getEvaluatorRoles().filter((role) =>{
        return role.program.requestKey === this.session.isEvaluatorWorkingForOtherInstitution();
      })[0];
    }
    this.accreditationProfiles = this.session.getInstitutionDirectoryProfiles();
    this.programProfiles = this.session.getProgramInstitutionDirectoryProfiles();
  }

  async logout(){
    // 1. Handle special authentication cases first
    if(this.session.isShibbolethAuthentication()){
      this.errorMessage.showErrorModal("Success", [{description: "You can now close your browser."}]);
      return;
    }
    try {
      const response = await firstValueFrom(this.apiCall.postData('/aeAMSlogoutUser/', {}));

      if (response.success) {
        this.session.logoutUser();
        const logOutUrl = this.session.getLogoutUrl();
        if (logOutUrl) {
          location.href = logOutUrl;
        } else {
          this.route.navigate(['/login']);
        }
        return;
      }
    }
    catch (error) {
      this.session.logoutUser();
      this.route.navigate(['/login']);
    }
    // 2. This is the default local logout action. It runs if:
    //    - The API call fails (from the catch block).
    //    - The API call succeeds but response.success is false.
    this.session.logoutUser();
    this.route.navigate(['/login']);
  };

  stopImpersonate() {
    this.session.stopImpersonateUser();
    this.blockUI.start();
    this.apiCall.getData('/aeAMSrestoreImpersonationUser/', {})
      .subscribe( (response) => {
        if (response.success) {
          this.auth.reloadSession()
            .pipe(first())
            .subscribe(()=>{
            this.route.navigate(['/home']);
          });
        }
        else {
          const currentUser = this.session.getUser();
          let userName: string = String();
          if(currentUser){
            userName = currentUser.username;
          }
          this.errorMessage.showErrorModal("There was a problem with stop impersonating user " + userName, response.dataError);
        }
        this.blockUI.stop();
      });
  }
  toggleUserMenu() {
    this.openMenu = !this.openMenu;
  }

  changeLightMode(event) {
    this.session.setLightMode(event);
    this.setLightMode(event);
  }
  setLightMode(lightMode: string) {
    /*this.renderer.removeClass(document.body, 'lightMode');
    this.renderer.removeClass(document.body, 'darkMode');
    this.renderer.addClass(document.body, lightMode);*/
  }

  ngOnDestroy() {
    for(let subscriber of this.subscribers){
      subscriber.unsubscribe();
    }
  }
}
